import axios from "axios";

axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
axios.defaults.withCredentials = true;
const base = window.bookingWidget?.base;


export default {
  availability(attraction, product_code, date, auto_next) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${base}/api/availability`, {
          params: {
            attraction: attraction.id,
            // date: moment(date).format("YYYY-MM-DD"),
            date: date,
            product_code: (product_code ? product_code : ''),
            auto_next: auto_next,
          },
        })
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  nextAvailability(attraction, date, product_code) {
    return new Promise((resolve, reject) => {
      axios
          .get(`${base}/api/availability/next`, {
            params: {
              attraction: attraction.id,
              // date: moment(date).format("YYYY-MM-DD"),
              date: date,
              product_code: (product_code ? product_code : ''),
            },
          })
          .then((response) => {
            resolve(response.data);
          })
          .catch((error) => {
            reject(error);
          });
    });
  },

  discounts(args) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${base}/api/discounts`, {
          params: args,
        })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  voucher(args) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${base}/api/voucher`, {
          params: args,
        })
        .then((response) => {
          resolve(response?.data);
        })
        .catch((error) => {
          reject(error.response);
        });
    });
  },

  quote(form) {
    return new Promise((resolve, reject) => {
      axios
        .post(`${base}/api/bookings/quote`, form)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },

  order(form) {
    return axios.post(`${base}/api/bookings`, form);
  },

  tmpOrder(booking, intent_id) {

    const data = {
      ...booking,
      intent_id: intent_id,
    };

    return new Promise((resolve, reject) => {
      axios
          .post(`${base}/api/tmp-bookings`, data)
          .then((response) => {
              console.log(response.data)
              resolve(response.data);
          })
          .catch((error) => {
              console.error(error)
              reject(error.response);
          });
    });
  },

  intents : {
    create(args) {
      return axios.post(`${base}/api/payments/intent`, args);
    },
    update(id, args) {
      return axios.post(`${base}/api/payments/intent/${id}`, args);
    },
  },


  bookings: {
      get(bookingNumber, token) {
          return axios.get(`${base}/api/bookings/${bookingNumber}`, {
              params: {
                  token: token
              }
          });
      },
      update(bookingNumber, token, form) {
          return axios.put(`${base}/api/bookings/${bookingNumber}`, form, {
              params: {
                  token: token
              }
          });
      },
      cancel(bookingNumber, token, form) {
          return axios.put(`${base}/api/bookings/${bookingNumber}/cancel`, form, {
              params: {
                  token: token
              }
          });
      },
  },

  attractions(args) {
    return axios
        .get(`${base}/api/attractions`, {
            params: args,
        });
  },

  options(args) {
    return axios
        .get(`${base}/api/options`, {
            params: args,
        });
  },
};
